import { Component, Input } from '@angular/core';

@Component({
  selector: 'md-chart-legend',
  template: require('./chart-legend.component.html'),
  styles: [require('./chart-legend.component.scss')]
})

export class ChartLegendComponent {
  @Input() labels = [];

}
